/**
 * Links into the app (SO-05.1): Universal Links / App Links on the link host and the
 * custom URL scheme both become an in-app path. The scheme and hosts come from the
 * mobile shell's identity (apps/mobile/identity.json: urlScheme, linkHost).
 */
export interface LinkConfig {
  /** custom URL scheme without ':', e.g. `marketpop` */
  scheme: string;
  /** https hosts whose links the app claims, e.g. `play.marketpop.example` */
  hosts: readonly string[];
}

/**
 * `https://<host>/restock/abc?ref=p1`, `marketpop://restock/abc?ref=p1` and
 * `/restock/abc?ref=p1` all give `/restock/abc?ref=p1`; anything else gives null.
 */
export function linkPath(url: string, c: LinkConfig): string | null {
  if (url.startsWith('/') && !url.startsWith('//')) return url;
  let u: URL;
  try {
    u = new URL(url);
  } catch {
    return null; // not a URL at all (untrusted notification data)
  }
  if (u.protocol === `${c.scheme.toLowerCase()}:`) {
    // marketpop://restock/abc parses with host "restock"; marketpop:///restock/abc with an empty host
    const path = `/${u.host}${u.pathname}`.replace(/\/{2,}/g, '/');
    return `${path.length > 1 ? path.replace(/\/$/, '') : path}${u.search}${u.hash}`;
  }
  if (u.protocol === 'https:' && c.hosts.some((h) => h.toLowerCase() === u.hostname)) return `${u.pathname}${u.search}${u.hash}`;
  return null;
}
